import config from "/config.json";
import { useApi } from "@/composition/useApi.js";
export default {
  state: () => ({
    api: config.API_URL,
    tokenCSRF: null,
    userInfo: null,
  }),
  mutations: {
    setTokenCSRF(state, token) {
      state.tokenCSRF = token;
    },
    clearTokenCSRF(state) {
      state.tokenCSRF = null;
    },
    setUserInfo(state, payload) {
      state.userInfo = payload;
    },
  },
  actions: {
    // валидные запросы
    logoutUser({ commit }) {
      const { api } = useApi();
      return api.post("/auth/logout", null).then(() => {
        commit("clearTokenCSRF");
        window.location.href = config.AUTH_URL;
      });
    },

    authUser({ commit }) {
      const { api } = useApi();
      return api
        .get(`/auth/user`)
        .then(r => {
          commit("setUserInfo", r.data);
        })
        .catch(r => {
          if (r.response.status == 401) window.location.href = config.AUTH_URL;
        });
    },
  },
};
